import initI18n from '@quicktools/shared-components/services/i18n';
import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { SingleToolsBootstrap } from '@quicktools/shared-components';
import NextThirdParty from '@quicktools/shared-components/components/common/NextThirdParty';

import translations from '../services/i18n/translation.json';
import { TRACKING_ID, TRACKING_ID_4, HOTJAR_ID, BUGSNAG_ID, VERSION } from '../configs';
import analytics from '../services/analytics';
import braze from '../services/braze/braze';

import type { AppProps } from 'next/app';

Bugsnag.start({
  apiKey: BUGSNAG_ID,
  plugins: [new BugsnagPluginReact()],
  appVersion: VERSION,
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

initI18n(translations);
analytics.init();
braze.init();

console.log('Using version:', VERSION);

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <NextThirdParty
        gAnalytics4Id={TRACKING_ID_4}
        gAnalyticsId={TRACKING_ID}
        hotjarId={HOTJAR_ID}
      />
      <SingleToolsBootstrap>
        <Component {...pageProps} />
      </SingleToolsBootstrap>
    </ErrorBoundary>
  );
}

export default MyApp;
